import React, { Fragment, useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function getTimeFragment(date) {
  return +`${date.getHours()}.${Math.floor(date.getMinutes() * 100 / 60)}`;
};

const initialState = {
  mealThreshold: 25,
  mealTimes: [
    {
      start: 6.5,
      end: 9.5,
    },
    {
      start: 11,
      end: 14,
    },
    {
      start: 16.5,
      end: 19.5,
    },
    {
      start: 20.5,
      end: 23.5,
    },
  ],
};

const NutritionSettingContext = React.createContext(initialState);

const initialMatch = (document.location.search || '').match(/[?&]meal=(\d)/);
const predefinedMealIndex = initialMatch ? initialMatch[1] - 1 : undefined;

export function NutritionSettingContextProvider({ children = <Fragment /> }) {

  const [selectedMealTime, selectMealTime] = useState(predefinedMealIndex);
  const [selectedMeal, selectMeal] = useState(undefined);
  const [mealThreshold, setMealThreshold] = useState(initialState.mealThreshold);
  const [mealTimes, setMealTimes] = useState(initialState.mealTimes);
  const location = useLocation();
  const history = useHistory();

  const { pathname, search = '' } = location;

  const fixUrl = useCallback((newLocation) => {
    history.replace(newLocation);
  }, [history]);

  const selectMealTimeAndFixUrl = (mealTime) => {
    selectMealTime(mealTime);

    const match = search.match(/[?&]meal=(\d)/);
    if (match && !mealTime) {
      let newSearch = search.replace(match[0], '');
      if (newSearch[0] === '&') {
        newSearch[0] = '?';
      }
      fixUrl({
        pathname,
        search: newSearch,
      });
    } else {
      if (match || (match === 0)) {
        const newSearch = search.replace(match[0], match[0].replace(match[1], +mealTime + 1))
        fixUrl({
          pathname,
          search: newSearch,
        });
      } else {
        fixUrl({
          pathname,
          search: `${search.length ? '&' : '?'}meal=${+mealTime + 1}`,
        });
      }
    }
  }

  const state = Object.freeze({
    mealTimes,
    mealThreshold,
    selectedMeal,
    selectMeal,
    selectedMealTime,
    selectMealTime: selectMealTimeAndFixUrl,
    setMealTimes,
    setMealThreshold,
  });

  return (
    <NutritionSettingContext.Provider value={state}>
      {children}
    </NutritionSettingContext.Provider>
  );
}

export default NutritionSettingContext;
